<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  created(){
    this.$request.get('queryHtmlSwitch',{platform:'h5'}).then(res => {
      if(res.err === 0) {
    
        this.$store.commit('saveIsMicroService',res.dat['H5-PPE'])
      }
    })
  },
  mounted(){
    // 仅测试(获取国家/省/市/区/详细地址)=====
    // let param = {
    //   pn: 'A0621010233504',
    // }
    // this.$request.get('queryCollectorAddressEs', param).then(res => {
    //   if(res.err === 0) {
    //     console.log("【queryCollectorAddressEs-res.data】",res.data);
    //   }
    // })
  },
};
</script>

<style lang="less">
#app {
  height: 100%;
}
// elementUI-clear
.el-input .el-input__clear,
.el-select .el-input .el-input__icon.el-icon-circle-close {
  font-size: 16px;
}

// 去掉IE默认密码眼睛
::-ms-clear,
::-ms-reveal{
  display:none;
}
// 首页注册密码眼睛
.password input {
  text-security: none!important;
  -webkit-text-security: none!important;
}

// 去除滚动条旁边白色方块
::-webkit-scrollbar-corner {
  background-color: inherit!important;
}

// 媒体查询============================
// @media screen and (max-width: 1920px) {}

@media screen and (max-width: 1440px) {
  // 新版-普通-能流右侧统计数据
  .paramNew {
    .paramNew-list {
      .param-data.device {
        padding: 0px!important;
        width: 174px!important;
      }
    }
  }
  // 管理====================
  // 新版-管理-设备信息-头部操作
  .deviceoperateAdminNew {
    .deviceoperate {
      height: 112px!important;
      // margin-bottom: 8px!important;
      padding: 8px 24px 8px 10px!important;
    }
    .top-operate {
      width: 50%!important;
      height: 112px!important;
      padding: 18px 0px 0px!important;
    }
    // 设备信息
    .aOperate {
      display: block!important;
      .aRowOne,.aRowTwo {
        display: flex!important;
        justify-content: flex-end!important;
        align-items: center!important;
      }
      .aRowOne {
        margin-bottom: 12px!important;
      }
      .aRowTwo {
        margin-bottom: 12px!important;
      }
    }
    .top-info {
      margin-top: -50px!important;
    }
    .usrBox {
      margin-top: -40px!important;
    }
  }
}
// 额外处理
@media screen and (max-width: 1400px) {
  // 管理====================
  // 新版-管理-头部
  .headerNewAdmin {
    // min-width: 1024px!important;
    // Logo
    // .logo {
    //   width: 192px!important;
    //   background: url(/img/logo-pic.db5a82c1.png) no-repeat center / 158px;
    // }
    // 菜单
    .menu {
      .menu-box {
        padding-left: 0px!important;
        .menu-link {
          padding: 0px 8px!important;
          .menu-title {
            margin-left: 0px!important;
          }
          i {
            display: none!important;
          }
        }
      }
    }
    // 切换新旧版
    .version-newbox {
      margin-right: 8px!important;
      .version-btn {
        i {
          display: none!important;
        }
      }
    }
    // 切换语言
    .language {
      .lang-img {
        margin-right: 0px!important;
      }
      .lang-text {
        display: none!important;
      }
    }
    .tool > :not(:first-child) {
      margin-left: 8px!important;
    }
    .nodeChange {
      margin-right: 8px!important;
    }
  }
  // 新版-管理-设备管理-侧栏
  .adminDeviceSidebarNew {
    .sidebar-list {
      padding: 20px 12px 0px!important;
      .sidebarViewBox {
        .btn-view {
          width: 168px!important;
        }
      }
    }
  } 
  // 新版-管理-账号管理-侧栏
  .adminAccountSidebarNew {
    width: 192px!important;
    .sidebar-list {
      padding: 20px 12px 0px!important;
    }
  }
  // 新版-管理-系统设置-侧栏
  .settingSidebarNew {
    .sidebarnew {
      width: 192px!important;
      padding: 30px 12px!important;
      .link {
        .title {
          font-size: 12px!important;
        }
      }
      .el-menu-item,.el-submenu {
        i {
          display: none!important;
        }
      }
      .el-submenu {
        .el-menu-item {
          min-width: unset;
        }
      }
    }
  }

  // 普通====================
  // 新版-普通-头部
  .headerNewUser {
    .logo {
      width: 192px!important;
      background: url(/img/logo-pic.db5a82c1.png) no-repeat center / 158px!important;
    }
  }

  // *******************************
  // 增：新版-普通-我的设备-侧栏
  .generalSidebarNew {
    width: 192px!important;
    .sidebar-list {
      padding: 20px 12px!important;
      .device-item {
        height: 88px!important;
        .device-item-info {
          height: 68px!important;
          .device-item-namebox {
            line-height: 1!important;
          }
          .device-item-idbox {
            line-height: 1!important;
            margin-top: 0px!important;
            .device-item-id {
              font-size: 12px!important;
            }
          }
        }
        .device-item-mask {
          height: 68px!important;
        }
      }
      .project-box{
        button {
          i {
            display: none!important;
          }
        }
      } 
    }
    // 标题切换项目
    .el-dropdown-pro {
      .showlabel {
        .countbox {
          .pnamebox {
            width: 46%!important;
          }
        }
      }
    }
  }
  // *******************************
}

@media screen and (max-width: 1300px) {
  // 普通==========
  // 新版-普通-我的设备-设备信息-头部操作
  .deviceoperateNew {
      padding: 0px 30px 0px 10px!important;
    .top-operate {
      width: 58%!important;
      height: 108px!important;
      padding: 16px 0px 0px!important;
    }
    // 设备信息
    .gOperate {
      display: block!important;
      .gRowOne,.gRowTwo {
        display: flex!important;
        justify-content: flex-end!important;
        align-items: center!important;
      }
      .gRowOne {
        margin-right: 0px!important;
      }
      .gRowTwo {
        margin-top: 10px!important;
      }
    }
  }
  // 新版-普通-我的设备-能流图
  .deviceStatisticAdaptNew {
    .flow {
      padding: 0px!important;
      margin-top: 0px!important;
      margin-right: 0px!important;
      // overflow: hidden!important;
      .scene {
        top: 0px!important;
      }
    }
    .paramNew {
      margin-top: 0px!important;
    }

    .AdaptBoxOut {
      height: 100%!important;
      overflow: scroll!important;
      margin-top: 12px!important;
      .AdaptBoxIn {
        height: 800px!important;
        display: flex!important;
        flex-direction: column-reverse!important;
      }
    }

  }
  // 新版-普通-我的设备-能流图右侧统计数据
  .deviceDetail {
    // .content
    .deviceStatisticAdaptNew {
      flex-direction: column-reverse!important;
      justify-content: flex-end!important;
      .paramNew {
        margin-bottom: 12px!important;
        .paramNew-list {
          display: flex!important;
          justify-content: space-between!important;
          align-items: center!important;
          .param-data.device {
            padding: 2px 30px 4px!important;
            .num {
              line-height: 1!important;
              font-size: 20px!important;
            }
            .name {
              line-height: 1!important;
              font-size: 12px!important;
              margin-top: 2px!important;
            }
          }
        }
      }
    }
  }
  // 新版-普通-我的设备-数采器信息
  .devicebelonginfoNew {
    .title {
      line-height: 40px!important;
    }
    .cell {
      line-height: 40px!important;
    }
    .infobox {
      .todetail {
        top: 8px!important;
      }
      .signalBox {
        margin-top: 10px!important;
      }
    }
  }
  // 管理==========
  // 新版-管理-设备管理-数采器信息 
  .devicebelonginfoAdminNew {
    .infobox {
      .signalBox {
        margin-top: 12px!important;
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  // 普通====================
  // 新版-普通-头部
  .headerNewUser {
    // min-width: 1024px!important;
    // Logo
    // .logo {
    //   width: 192px!important;
    //   background: url(/img/logo-pic.db5a82c1.png) no-repeat center / 158px!important;
    // }
    // 菜单
    .menu {
      .menu-box {
        padding-left: 0px!important;
        .menu-link {
          padding: 0px 8px!important;
          .menu-title {
            margin-left: 0px!important;
          }
          i {
            display: none!important;
          }
        }
      }
    }
    // 切换新旧版
    .version-newbox {
      margin-right: 8px!important;
      .version-btn {
        i {
          display: none!important;
        }
      }
    }
    // 切换语言
    .language {
      .lang-img {
        margin-right: 0px!important;
      }
      .lang-text {
        display: none!important;
      }
    }
    .tool > :not(:first-child) {
      margin-left: 8px!important;
    }
    .nodeChange {
      margin-right: 8px!important;
    }
  }
  // 新版-普通-我的设备-Tab
  .deviceDetail {
    .tab-item {
      padding: 1.2vh 20px!important;
    }
  }
  // 新版-普通-我的设备-数采器信息-头部操作
  .devicebelongoperate {
    .gTool {
      display: block!important;
      .gRowA,.gRowB {
        display: flex!important;
        justify-content: flex-end!important;
        align-items: center!important;
      }
      .gRowA {
        margin-right: 0px!important;
      }
      .gRowB {
        margin-top: 10px!important;
      }
    }
  }
  // 新版-普通-我的设备-数采器信息
  .devicebelonginfoNew {
    .title {
      line-height: 40px!important;
    }
    .cell {
      line-height: 40px!important;
    }
    .infobox {
      .todetail {
        top: 8px!important;
      }
    }
  }
  // 新版-普通-项目管理
  .project {
    .p-main {
      .p-panel {
        width: 80%!important;
      }
    }
  }



  
  // 管理====================
  // 新版-管理-设备管理-数采器信息-头部操作
  .devicebelongoperate {
    .aTool {
      display: block!important;
      .aRowA,.aRowB {
        display: flex!important;
        justify-content: flex-end!important;
        align-items: center!important;
      }
      .aRowA {
        margin-right: 0px!important;
      }
      .aRowB {
        margin-top: 10px!important;
      }
    }
  }
  // 新版-管理-设备管理-数采器信息
  .devicebelonginfoAdminNew {
    .title {
      line-height: 45px!important;
    }
    .cell {
      line-height: 45px!important;
    }
    .infobox {
      .todetail {
        top: 10px!important;
      }
    }
  }
  // 新版-管理-设备管理-编辑设备控制权限弹框
  .authorityModal {
    .dialog-outborder {
      width: 90%!important;
    }
    .dialog-content {
      width: auto!important;
    }
    .editControl {
      .searchprotocol {
        .searchName {
          width: 122px!important;
        }
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  // 普通====================
  // 新版-普通-头部
  .headerNewUser {
    // min-width: 1024px!important;
    // Logo
    .logo {
      width: 192px!important;
      background: url(/img/logo-pic.db5a82c1.png) no-repeat center / 158px!important;
    }
  }
  // 新版-普通-我的设备-侧栏
  .generalSidebarNew {
    width: 192px!important;
    .sidebar-list {
      padding: 20px 12px!important;
      .device-item {
        height: 88px!important;
        .device-item-info {
          height: 68px!important;
          .device-item-namebox {
            line-height: 1!important;
          }
          .device-item-idbox {
            line-height: 1!important;
            margin-top: 0px!important;
            .device-item-id {
              font-size: 12px!important;
              .item-num {
                transform: scale(0.83);
              }
            }
          }
        }
        .device-item-mask {
          height: 68px!important;
        }
      }
      .project-box{
        button {
          i {
            display: none!important;
          }
        }
      } 
    }
    // 标题切换项目
    .el-dropdown-pro {
      .showlabel {
        .countbox {
          .pnamebox {
            width: 42%!important;
          }
        }
      }
    }
  }
  // 新版-普通-我的设备-Tab
  .deviceDetail {
    .tab-item {
      padding: 1.2vh 10px!important;
    }
  }
  // 新版-普通-我的设备-设备信息-头部操作
  .deviceoperateNew {
      padding: 0px 30px 0px 10px!important;
    .top-operate {
      width: 58%!important;
      height: 108px!important;
      padding: 16px 0px 0px!important;
    }
    // 设备信息
    .gOperate {
      display: block!important;
      .gRowOne,.gRowTwo {
        display: flex!important;
        justify-content: flex-end!important;
        align-items: center!important;
      }
      .gRowOne {
        margin-right: 0px!important;
      }
      .gRowTwo {
        margin-top: 10px!important;
      }
    }
  }
  // 新版-普通-我的设备-能流图
  // .deviceStatisticAdaptNew {
  //   .flow {
  //     padding: 0px!important;
  //     margin-top: 0px!important;
  //     margin-right: 0px!important;
  //   }
  // }
  // 新版-普通-我的设备-能流图右侧统计数据
  // .deviceDetail {
  //   // .content
  //   .deviceStatisticAdaptNew {
  //     flex-direction: column-reverse!important;
  //     justify-content: flex-end!important;
  //     .paramNew {
  //       margin-bottom: 12px!important;
  //       .paramNew-list {
  //         display: flex!important;
  //         justify-content: space-between!important;
  //         align-items: center!important;
  //         .param-data.device {
  //           padding: 2px 30px 4px!important;
  //           .num {
  //             line-height: 1!important;
  //             font-size: 20px!important;
  //           }
  //           .name {
  //             line-height: 1!important;
  //             font-size: 12px!important;
  //             margin-top: 2px!important;
  //           }
  //         }
  //       }
  //     }
  //   }
  // }
  // 管理====================
  // 新版-管理-设备信息-头部操作
  .deviceoperateAdminNew {
    // padding: 0px 30px 0px 10px!important;
    .deviceoperate {
      height: 144px!important;
      margin-bottom: 8px!important;
      padding: 2px 24px 8px 10px!important;
    }
    .top-operate {
      width: 58%!important;
      padding: 0px!important;
    }
    // 设备信息
    .aOperate {
      display: block!important;
      .aRowOne,.aRowTwo {
        display: flex!important;
        justify-content: flex-end!important;
        align-items: center!important;
      }
      .aRowOne {
        margin-bottom: 12px!important;
      }
      .aRowTwo {
        margin-bottom: 12px!important;
        display: flex!important;
        flex-direction: column!important;
        align-items: flex-end!important;
        .aRowTwoBoxOne {
          margin-bottom: 12px!important;
        }
      }
    }
    .top-info {
      margin-top: -62px!important;
    }
    .usrBox {
      margin-top: -46px!important;
    }
  }
  // 新版-管理-设备管理-编辑设备控制权限弹框
  .authorityModal {
    // .dialog-outborder {
    //   width: 90%!important;
    // }
    // .dialog-content {
    //   width: auto!important;
    // }
    .editControl {
      .searchprotocol {
        .searchName {
          width: 96px!important;
          min-width: 96px!important;
        }
      }
    }
  }
}
</style>
